import styled from "styled-components";

const TopbarViewWrapper = styled.div`
  .topbarViewContainer {
    height: 100vh;

    .topbarViewContentHeader {
      display: flex;
      align-items: center;
      padding-left: 10px;
    }

    .topbarViewLayout {
      overflow-y: hidden;
    }
    .topbarViewContentLayout {
      overflow-y: auto;
      overflow-x: hidden;

      .topbarViewContent {
        display: grid;
        grid-template-rows: auto 70px;
        padding: 10px 40px 0px;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .ant-layout-footer {
      padding: 0.5em;
      padding-top: 1em;
    }
  }
  .topbarViewContentFooter {
    text-align: center;
  }
`;

export default TopbarViewWrapper;
